import React from 'react';
import { motion } from 'framer-motion';
import { Network, BookOpen } from 'lucide-react';
interface BottomNavProps {
  activeTab: 'tree' | 'stories';
  setActiveTab: (tab: 'tree' | 'stories') => void;
}
export function BottomNav({
  activeTab,
  setActiveTab
}: BottomNavProps) {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 pb-safe pt-2 px-4 bg-gradient-to-t from-warm-bg via-warm-bg to-transparent pointer-events-none" data-id="element-44">
      <div className="bg-warm-surface/90 backdrop-blur-md border border-warm-border rounded-full p-1 flex items-center justify-between mb-4 pointer-events-auto shadow-warm relative" data-id="element-45">
        {(['tree', 'stories'] as const).map(tab => {
        const isActive = activeTab === tab;
        return <button key={tab} onClick={() => setActiveTab(tab)} className="relative flex-1 flex items-center justify-center gap-2 py-3 rounded-full text-sm font-medium z-10" data-id="element-46">
              {isActive && <motion.div layoutId="bottom-nav-indicator" className="absolute inset-0 bg-warm-border rounded-full" transition={{
            type: 'spring',
            bounce: 0.2,
            duration: 0.6
          }} data-id="element-47" />}
              <span className={`relative z-10 flex items-center gap-2 ${isActive ? 'text-warm-cyan' : 'text-warm-muted'}`} data-id="element-48">
                {tab === 'tree' ? <Network className="w-4 h-4" data-id="element-49" /> : <BookOpen className="w-4 h-4" data-id="element-50" />}
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </span>
            </button>;
      })}
      </div>
    </div>;
}